import { render, staticRenderFns } from "./AnnualIncomeField.vue?vue&type=template&id=bb0a6552&scoped=true"
import script from "./AnnualIncomeField.vue?vue&type=script&lang=js"
export * from "./AnnualIncomeField.vue?vue&type=script&lang=js"
import style0 from "./AnnualIncomeField.vue?vue&type=style&index=0&id=bb0a6552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0a6552",
  null
  
)

export default component.exports